import { LOGIN, LOGOUT, PROFILE_PHOTO } from '../../constants/reducerTypes';

const userProfile = window.localStorage.getItem('userProfile')
  ? JSON.parse(window.localStorage.getItem('userProfile'))
  : null;
let initialAuthState = { isAuthenticated: false, userDetails: {} };
if (userProfile) {
  // to check gnav access token is available
  if(userProfile.gnavAccessToken)
  {
    const { expiresOn } = userProfile;
    const currentTime = new Date().getTime();
    if (currentTime < expiresOn) {
      initialAuthState = {
        isAuthenticated: !!(userProfile && userProfile.accessToken),
        userDetails: userProfile && userProfile.accessToken ? userProfile : {},
      };
    }
  }  
}

const authenticationReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case LOGIN:
      if (action.payload) {
        const userDetailsData = JSON.stringify(action.payload);
        window.localStorage.setItem('userProfile', userDetailsData);
      }
      return {
        ...state,
        userDetails: action.payload,
        isAuthenticated: !!action.payload,
      };
    case PROFILE_PHOTO:
      return {
        ...state,
        profilePhoto: action.payload
      };
    case LOGOUT:
      window.localStorage.removeItem('userProfile');
      window.sessionStorage.removeItem('cartCompareData');
      return {
        ...state,
        userDetails: {},
        isAuthenticated: false,
      };
    default:
      return state;
  }
};
export default authenticationReducer;
